const pt = {
  global: {
    see_more: 'Ver mais',
    last_news: 'Ultimas Notícias',
    view_all: 'Ver Todos',
    search: 'Pesquisar',
    title: 'Sistema Nacional de Qualificações',
    description:
      'Serviço responsável pela promoção, desenvolvimento e integração das ofertas de formação técnico-profissional através do Catálogo Nacional de Qualificações, permitindo a avaliação e certificação de competências profissionais.',
    no_data_found: 'Nenhum Resultado Encontrado',
    go_back: 'Voltar',
  },
  metadata: {
    home_title: 'Titulo Pagina Inicial',
    home_description: 'Descrição Pagina Inicial',
  },
  navigation: {
    home: 'Início',
    ucsnq: 'UCSNQ',
    snq: 'SNQ',
    snq_component: 'Componentes SQN',
    catalog: 'Catálago Nacional de Qualificação',
    equivalency: 'Equivalência',
    rvcc: 'RVCC',
    square: 'Quadro Nacional de Qualificação',
    document: 'Documentos',
    news: 'Notícias',
    contact: 'Contatos',
  },
  language: {
    pt: 'Portuguess',
    en: 'Inglês',
  },
  homePage: {
    component_of: 'Componete de',
    snq: 'Sistema Nacional de Qualificações',
    catalog: 'Catálogo Nacional de Qualificações',
    catalog_ordinance: 'Portaria nº 9/2020, 20 Fevereiro',
    equivalency: 'Equivalências',
    rvcc: 'RVCC Profissional',
    rvcc_ordinance: 'Portaria nº 9/2020, 20 Fevereiro ',
    square: 'Quadro Nacional De Qualificações',
    square_ordinance: 'Portaria nº 10/2020, 20 Fevereiro',
    access_platform: 'Acesse as seguintes plataformas',
    access_platform_form_info: 'para mais informações',
    statics_start: 'Nossas',
    statics_end: 'estatísticas',
    partners_start: 'Nossos',
    partners_end: 'parceiros',
    faq_start: 'Perguntas',
    faq_end: 'Frequentes',
    news_start: 'Ultimas ',
    news_end: 'Notícias',
    about_us_start: 'O que dizem',
    about_us_end: 'Sobre Nós',
    platform: {
      name1: 'PAEF',
      name2: 'Carteira Profissional',
      name3: 'Solicitar Equivalência',
      name4: 'Simular Qualificação',
    },
    simulate_qualification: {
      title_start: 'Simular',
      title_end: 'Qualificações',
      description:
        'Essa funcionalidade permite que os usuários descubram as qualificações disponíveis com base em seu nível de escolaridade, proporcionando uma visualização direta das opções educacionais acessíveis.',
      label: {
        school_level: 'Nível Escolaridade',
        training_level: 'Nível Formação',
      },
    },

    banner: {
      main_title1: 'Sistema',
      main_title2: 'Nacional De',
      main_title3: 'Qualificações',
      slogan: 'Promovendo Mais Qualificação e Melhor Empregabilidade',
      content:
        'Serviço responsável pela promoção, desenvolvimento e integração das ofertas de formação técnico-profissional através do Catálogo Nacional de Qualificações, permitindo a avaliação e certificação de competências profissionais.',
    },
  },
  catalogPage: {
    catalog_start: 'Catálogo Nacional de',
    catalog_end: 'Qualificações',
    catalog_description:
      'O Catálogo Nacional de Qualificações (CNQ) é um instrumento dinâmico, de gestão estratégica de qualificações profissionais que integra o Sistema Nacional de Qualificações (Decreto-Lei nº 66/2010, de 27 de dezembro).',
    filter: 'Filtro de pesquisas',
    searchResult: 'Resultado: {{number}} Qualificação Encontrado.',
    level: 'Nível',
    modules: '{{module}}  Módulos - {{hours}} Horas',

    school_level: '**Pré-requisitos** - {{name}}',
    codes: '**Códigos** - {{name}}',
    labels: {
      family: 'Familia',
      qualification: 'Qualificação',
      level: 'Nivel',
    },
  },
  catalogDetailsPage: {
    professional_profile_start: 'Perfil',
    professional_profile_end: 'Profissional',
    training_program_start: 'Programa',
    training_program_end: 'Formativo',
    unit_skill_start: 'Unidades',
    unit_skill_end: 'Competências',
    unit_skill: 'Unidade Competência',
    modules: 'Módulos',
    codes: 'Códigos',
    hours: 'Horas',
    document: 'Documentos',
    access_qualification_start: 'Via de Acesso á ',
    access_qualification_end: 'Qualificação',
    general_doc: 'Documentanção Geral',
    access_training: 'Formação Profissional',
    access_rvcc: 'RECONHECIMENTO, VALIDAÇÃO E CERTIFICAÇÃO DE COMPETÊNCIAS',
  },
  contactPage: {
    content_start: 'Entre em ',
    content_end: 'Contacto',
    hour: 'Horario',
    hour_content: 'Segunda a Sexta Feira - 08:00 to 17:00',

    contact: 'Contact0',
    contact_content: '+238 333 7076/7061/7059',
    pbx: 'PBX',
    pbx_content: '+238 333 7021/7055',
    address: 'Plateau - Predio Antigo edifício do Banco de Cabo Verde (BCV), no 6º andar ',
    msg_content:
      'Por favor, deixe-nos saber se você tem uma pergunta, quer deixar um comentário, ou gostaria de obter mais informações sobre o Sistema Nacional de Qualificações.',
    msg: 'Mensagem',
  },
  rvccPage: {
    content_start: 'Reconhecimento, Validação e',
    content_end: 'certificação de competências profissionais (RVCC)',
    content:
      'O Decreto-lei nº 54/2014 de 22 de setembro é o Regime jurídico que regula o Sistema de Reconhecimento, Validação e Certificação de Competências Profissionais adquiridas e desenvolvidas ao longo da vida, nomeadamente em contexto de trabalho. RVCC é o processo formal que permite aos indivíduos obter o reconhecimento, a validação e a certificação das suas competências profissionais adquiridas ao longo da vida, independente de como tenham sido obtidas. Este processo destina-se a indivíduos com idade igual ou superior a 25 anos e experiência profissional mínima de 5 anos. O reconhecimento, validação e certificação de competências profissionais desenvolve-se com base nos referenciais de competências profissionais integrados no Catálogo Nacional de Qualificações (CNQ), conforme o artigo 23 do Decreto- Lei nº 66/2010, de 27 de Dezembro. A Unidade de Coordenação do Sistema Nacional de Qualificações (UC-SNQ) é a entidade responsável pela organização e coordenação do sistema de reconhecimento, validação e certificação de competências profissionais. O processo de certificação de competências profissionais é assegurado por entidades acreditadas, autorizadas para o efeito, com o apoio e supervisão da Direção Geral do Emprego e da Unidade de Coordenação do Sistema Nacional de Qualificações.',
    objective: {
      content_start: 'Principais',
      content_end: 'Objectivos',
      content_1: 'Aumentar o nível de qualificação profissional dos jovens e adultos',
      content_2: 'Melhorar a empregabilidade, incentivando a aprendizagem ao longo da vida',
    },
    documents: {
      content_start: 'Documentos',
      content_end: 'NECESSÁRIOS',
      content_1:
        'Curriculum vitae para atestar a consistência da experiência profissional do candidato ao processo de RVCC;',
      content_2:
        'Declarações dos empregadores para confirmação do exercício de atividade profissional pelo tempo mínimo requerido;',
      content_3:
        'Declarações dos empregadores para confirmação do exercício de atividade profissional pelo tempo mínimo requerido;',
      content_4:
        'Outros meios de prova considerados necessários pela entidade responsável pelo desenvolvimento do processo de RVCC.',
    },
    process: {
      content_start: 'Etapas do',
      content_end: 'PROCESSO RVCC',
      content:
        'Este processo é constituído por um conjunto de etapas e procedimentos metodológicos e de certificação que permitem aos indivíduos obter o reconhecimento e a certificação de competências profissionais adquiridas de forma não formal ou informal',
      content_1: 'Informação e Orientação',
      content_2: 'Reconhecimento',
      content_3: 'Validação',
      content_4: 'Certificação de Competências',
    },
    responsible: {
      content_start: 'Entidades',
      content_end: 'RESPONSÁVEIS PELO RVCC',
      content: 'Fazem parte da rede de operadores do sistema RVCC um conjunto de entidades:',
      content_1: 'Direção Geral de Emprego',
      content_2: 'Unidade de Coordenação do Sistema Nacional de Qualificações (UC-SQN)',
      content_3: 'Entidades formadoras públicas e privadas, devidamente acreditadas',
      content_4: 'Escolas Técnicas',
    },
    access: {
      content_start: 'Regime de Acesso',
      content_end: 'TAXAS',
      content: 'Taxas a pagar para ter acesso ao RVCC:',
      content_1: 'Inscrição no processo de RVCC: 5.000$00(cinco mil escudos)',
      content_2:
        'Participação no processo de certificação de competências profissionais: 15.000$00 (quinze mil escudos)',
      content_3: 'Certificação de competências profissionais: 8.000$00 (oito mil escudos)',
      content_4: 'Emissão de documentos diversos: 1.000$00 (mil escudos)',
    },
  },
  squarePage: {
    content_start: 'Quadro Naticional de',
    content_end: 'Qualificaçoes',
    content:
      'O QNQ é regulado pelo <span style="color:blue">decreto-lei nº 65/2010, de 27 de dezembro </span>, revogado pela <span style="color:blue">portaria conjunta nº 10/2020, de 20 de fevereiro </span>.',
    accordion: {
      what_is: {
        title: 'O que é Quadro Naticional de Qualificaçoes',
        content_1:
          'O Quadro Nacional de Qualificações (QNQ) é um quadro de referência único que classifica todas as qualificações produzidas no âmbito do sistema educativo e formativo nacional, independentemente da via de acesso, conforme definido na portaria conjunta nº 10/2020, de 20 de fevereiro.',
        content_2:
          'O QNQ é regulado pelo decreto-lei nº 65/2010, de 27 de dezembro, revoga pela portaria conjunta nº 10/2020, de 20 de fevereiro.',
      },
      qualification_level: {
        title: 'O que são os níveis de qualificação?',
        content:
          'Constituem-se como os indicadores da complexidade e/ou profundidade de conhecimentos,habilidades e atitudes (autonomia e responsabilidade) que um indivíduo deverá ser capaz de demonstrar possuir num determinado nível de qualificação.',
      },
      structure: {
        title: 'Qual é a sua estrutura?',
        description:
          'O QNQ estrutura-se em 8 níveis de qualificação, cada um definido por um conjunto de indicadores que especificam os resultados de aprendizagem correspondentes às qualificações nesse nível.',
        table: {
          h1: 'NÍVEIS',
          h2: 'CONHECIMENTOS',
          h3: 'Habilidades',
          h4: 'AUTONOMIA E RESPONSABILIDADES',
          content: {
            level1: {
              level: 'Nível 1',
              knowledge: 'Basic general knowledge.',
              skills: 'Basic skills needed to carry out simple tasks.',
              autonomy: 'Work or study under direct supervision in a structured context',
            },
            level2: {
              level: 'Nível 2',
              knowledge: 'Conhecimentos factuais básicos numa área de trabalho ou de estudo.',
              skills:
                'Aptidões cognitivas e práticas básicas necessárias para a aplicação da informação adequada à realização de tarefas e à resolução de problemas correntes por meio de regras e instrumentos simples.',
              autonomy: 'Trabalhar ou estudar sob supervisão, com um certo grau de autonomia.',
            },
            level3: {
              level: 'Nível 3',
              knowledge:
                'Conhecimentos de factos, princípios, processos e conceitos gerais numa área de estudo ou de trabalho.',
              skills:
                'Uma gama de aptidões cognitivas e práticas necessárias para a realização de tarefas e a resolução de problemas através da seleção e aplicação de métodos, instrumentos, materiais e informações básicas.',
              autonomy:
                'Assumir responsabilidades para executar tarefas numa área de estudo ou de trabalho. Adaptar o seu comportamento às circunstâncias para fins da resolução de problemas.',
            },
            level4: {
              level: 'Nível 4',
              knowledge:
                'Conhecimentos factuais e teóricos em contextos alargados numa área de estudo ou de trabalho.',
              skills:
                'Uma gama de aptidões cognitivas e práticas necessárias para conceber soluções para problemas específicos numa área de estudo ou de trabalho.',
              autonomy:
                'Gerir a própria atividade no quadro das orientações estabelecidas em contextos de estudo ou de trabalho, geralmente previsíveis, mas suscetíveis de alteração. Supervisionar as atividades de rotina de terceiros, assumindo determinadas responsabilidades em matéria de avaliação e melhoria das atividades em contextos de estudo ou de trabalho.',
            },
            level5: {
              level: 'Nível 5',
              knowledge:
                'Conhecimentos abrangentes, especializados, factuais e teóricos numa determinada área de estudo ou de trabalho e consciência dos limites desses conhecimentos.',
              skills:
                'Uma gama abrangente de aptidões cognitivas e práticas necessárias para conceber soluções criativas para problemas abstratos.',
              autonomy:
                'Gerir e supervisionar em contextos de estudo ou de trabalho sujeitos a alterações imprevisíveis. Rever e desenvolver o seu desempenho e o de terceiros.',
            },
            level6: {
              level: 'Nível 6',
              knowledge:
                'Conhecimento aprofundado de uma determinada área de estudo ou de trabalho que implica uma compreensão crítica de teorias e princípios.',
              skills:
                'Aptidões avançadas que revelam a mestria e a inovação necessárias à resolução de problemas complexos e imprevisíveis numa área especializada de estudo ou de trabalho.',
              autonomy:
                'Gerir atividades ou projetos técnicos ou profissionais complexos, assumindo a responsabilidade da tomada de decisões em contextos de estudo ou de trabalho imprevisíveis. Assumir responsabilidades em matéria de gestão do desenvolvimento profissional individual e coletivo.',
            },
            level7: {
              level: 'Nível 7',
              knowledge:
                'Conhecimentos altamente especializados, alguns dos quais se encontram na vanguarda do conhecimento numa determinada área de estudo ou de trabalho, que sustentam a capacidade de reflexão original e ou investigação. Consciência crítica das questões relativas aos conhecimentos numa área e nas interligações entre várias áreas.',
              skills:
                'Aptidões especializadas para a resolução de problemas em matéria de investigação e ou inovação, para desenvolver novos conhecimentos e procedimentos e integrar os conhecimentos de diferentes áreas.',
              autonomy:
                'Gerir e transformar contextos de estudo ou de trabalhos complexos, imprevisíveis e que exigem abordagens estratégicas novas. Assumir responsabilidades por forma a contribuir para os conhecimentos e as práticas profissionais e/ou para rever o desempenho estratégico de equipas.',
            },
            level8: {
              level: 'Nível 8',
              knowledge:
                'Conhecimentos de ponta na vanguarda de uma área de estudo ou de trabalho e na interligação entre áreas.',
              skills:
                'As aptidões e as técnicas mais avançadas e especializadas, incluindo capacidade de síntese e de avaliação, necessárias para a resolução de problemas críticos na área da investigação e/ou da inovação para o alargamento e a redefinição dos conhecimentos ou das práticas profissionais existentes.',
              autonomy:
                'Demonstrar um nível considerável de autoridade, inovação, autonomia, integridade científica ou profissional e assumir um firme compromisso no que diz respeito ao desenvolvimento de novas ideias ou novos processos na vanguarda de contextos de estudo ou de trabalho, inclusive em matéria de investigação.',
            },
          },
        },
      },
    },
  },
  newsPage: {
    content_start: 'Nossos ',
    content_end: 'DESTAQUES',
    news: 'Noticias',
  },
  documentPage: {
    content_start: 'Documentação ',
    content_end: 'Geral',
    table: {
      title: 'Título',
      size: 'Tamanho',
      action: 'Ações',
    },
  },
  equivalencyPage: {
    content_start: 'Comissão Nacional de',
    content_end: 'EQUIVALÊNCIAS PROFISSIONAIS',
    content:
      'Este órgão especializado do SNQ, cujo serviço de secretariado é garantido pela Unidade de Coordenação do SNQ (UC-SNQ) desde 2015, avalia e emite pareceres sobre a atribuição de Equivalências Profissionais a cursos de formação ou qualificação profissional realizados no estrangeiro ou em escolas ou entidades de formação profissional estrangeiras sediadas em Cabo Verde.',
    cost: 'Custo',
    cost_value: '1000 ESCUDOS',
    account:
      ' Este valor será depositado na Conta Nº 30848162.10.004, em nome do Fundo de Promoção do Emprego e da Formação (FPEF), domiciliada na Caixa Económica de Cabo Verde.',
    submit: 'Submeter Candidatura',
    steppers: {
      personal_data: 'Dados Pessoais',
      academic_data: 'Dados Académicos',
      attachments: 'Anexos ',
      next: 'Próximo',
      back: 'Voltar',
      submit: 'Gravar',
    },
    forms: {
      l_name: 'Nome Completo',
      l_address: 'Morada',
      l_sex: 'Sexo',
      l_nationality: 'Nacionalidade',
      l_birth_date: 'Data Nascimento',
      l_email: 'Email',
      l_document_type: 'Tipo Documento',
      l_document_number: 'Número de Documento',
      l_emission: 'Emitido Em',
      l_telephone: 'Telefone',
      l_phone: 'Telemóvel',
      l_course: 'Curso',
      l_start_year: 'Ano De Início',
      l_end_year: 'Ano De Término',
      l_country: 'País ',
      l_nif: 'NIF',
      l_requirement: 'Requerimento',
      l_habilitation_certicate: 'Certificado Das Habilitações Académicas',
      h_t_habilitation_certicate: 'Ou Equivalência Escolar',
      l_course_certificate: 'Certificado',
      h_t_course_certificate: 'Ou Diploma Do Curso De Formação Profissional',
      l_curriculum: 'Currículo',
      h_t_curriculum: 'Histórico Do Curso De Formação Profissional',
      l_document_tradoction: 'Tradução Autenticada Dos Documentos Redigidos Em Língua Estrangeira',
      l_identification_document: 'Cópia Autenticada Do B.I. / Passaporte',
      l_proof_of_residence: 'Comprovativo De Autorização De Residência',
      h_t_proof_of_residence: 'Caso Tratar-se De Cidadão Estrangeiro',
      l_proof_of_payment: 'Comprovativo De Pagamento',
    },
    session_info: {
      who_can_request_title: 'Quem pode solicitar ?',
      who_can_request_content:
        'Qualquer cidadão cabo-verdiano e estrangeiros detentores de qualificações profissionais obtida em sistema de formação profissional no estrangeiro ou numa escola estrangeira sediada em Cabo Verde.',
      how_can_request_title: 'Como solicitar?',
      how_can_request_content:
        'De forma online através do link …. ou de forma presencial, na UC-SNQ, sito no platô, avenida Amilcar Cabral, antigo edificio do Banco de Cabo Verde, no 6ºandar.',
      clarification_contact: 'Contacto para esclarecimento',
      clarification_contact_content:
        'Telef. +238 333 7055/7076/7061  ou e-mail: snqcv.uc@gmail.com',
      payment_fees: 'Quais as taxas a pagar?',
      payment_fees_content1: 'Pedido  de equivalência independentemente da sua concessão: 1000$00.',
      payment_fees_content2: 'Emissão do certificado: 2 500$00.',
      payment_fees_content3: 'Emissão de 2ª via do certificado: 1 300$00.',
      document_title: 'Quais os documentos necessários?',
      document_content1:
        'a) Requerimeto derigido ao /a coordenador (a) do Sistema Nacional de Qualificações;',
      document_content2: 'b) Copia de declaração de NIF;',
      document_content3:
        'c) Copia autenticado do certificado das habilitaçoes académicas  ou certidão de equivalencia escolar;',
      document_content4:
        'd) Cópia autenticado do certificado ou diploma do curso de formação profissional;',
      document_content5:
        'e) Copia autenticado do currículo ou histórico, com a respetica carga horária por módulos;',
      document_content6:
        'f) Traduçao em portugueês autenticado dos documentos redigidos em lingua estrangeira;',
      document_content7: 'g) Fotocópia autenticado do BI/CNI/Passaporte;',
      document_content8: 'h) Cópia autenticado de autorização de residência (Estrangeiro);',
      document_content9:
        'i) Comprovativo de pagamento efetado mediante DUC emitido pel Fundo de Promoçao de Emprego e Formçãp ( FPEF).',
      document_footer:
        'Os documentos originiais referidos na alinea c), d), e) e f) devem ser autenticados pela Emabaixada ou Consulado de Cabo Verde no estrangeiro, ou, na falta daquele, pelo departamento governamental responsável pelas relações exteriores em Cabo Verde.',
    },
  },
  snqPage: {
    about_start: 'Sobre',
    about_end: 'SNQ',
    about_content:
      'O Sistema Nacional de Qualificações de Cabo Verde foi criado em 2010 através do <span style="color:blue">Decreto-Lei nº 20/2010, de 14 de junho </span>, alterado pelo <span style="color:blue">Decreto-lei nº 4/2018, de 10 de janeiro </span>, que estabelece o novo regime jurídico que regula a matéria.',
    scope_start: 'Nosso',
    scope_end: 'Âmbito',
    scope_content_1:
      'O Sistema Nacional de Qualificações abrange instrumentos e ações necessários à promoção, ao desenvolvimento e à integração das ofertas de formação técnico-profissional, através do Catálogo Nacional de Qualificações, permitindo a avaliação e a certificação de competências profissionais adquiridas ao longo da vida, de modo a incentivar o desenvolvimento profissional, humano e social das pessoas e responder às necessidades do sistema produtivo.',

    scope_content_2:
      'As principais ações, no âmbito do SNQ, são desenvolvidas por meio de elaboração e implementação de Referenciais de Qualificações Profissionais, concretamente, Referenciais de Competências que espelham Perfis Profissionais exigidos no mercado de trabalho e Referenciais de Formação que correspondem aos Programas formativos associados a esses Perfis, com a visão de responder às necessidades, atuais e emergentes, do mercado.',
    scope_content_3:
      'O mérito do SNQ está, essencialmente, em congregar esforços de diversos atores do Setor da Educação, Formação e Emprego, com a finalidade de melhorar a estrutura do sistema de educação e formação profissional cabo-verdiano, em termos de qualidade, para melhor empregabilidade.',
    scope_content_4:
      'O SNQ é dirigido pelos membros do Governo, responsáveis pelas áreas da Educação, Formação Profissional e Emprego, através do serviço central encarregue pela coordenação das políticas de qualificação profissional - a Unidade de Coordenação do Sistema Nacional de Qualificações (UC-SNQ).',
    goal_start: 'Principais',
    goal_end: 'OBJETIVOS',
    goals: {
      content_1: 'Promover a integração dos sistemas da Educação, Formação e Emprego;',
      content_2:
        'Estruturar ofertas de formação técnico-profissional uniformizadas, ajustadas às necessidades atuais e emergentes do mercado de trabalho;',
      content_3:
        'Promover a igualdade de oportunidades no acesso às profissões, bem como à empregabilidade e ao desenvolvimento do empreendedorismo;',
      content_4:
        'Promover o reconhecimento de competências profissionais, incluindo experiências de trabalho e de vida, adquiridas nos vários contextos de aprendizagem;',
      content_5:
        'Incentivar o rigor e a objetividade na análise dos diplomas/certificados de formação profissional obtidos em sistemas formativos estrangeiros.',
    },
    snq_component_start: 'Componentes do',
    snq_component_end: 'SISTEMA NACIONAL DE QUALIFICAÇÃO',
    square_title: 'QUADRO NACIONAL DE QUALIFICAÇÕES',
    square_content_1:
      'É um instrumento de classificação de todas as qualificações produzidas no país, a nível dos diferentes subsistemas de ensino, criado com a publicação do <span style="color:blue">Decreto-lei nº 65/2010, de 27 de dezembro </span>, e regulado, atualmente, pela <span style="color:blue">Portaria conjunta nº 10/2020, de 20 de fevereiro. </span>',
    square_content_2:
      'O QNQ estrutura-se em oito (8) níveis de qualificação, definidos com base em três descritores: Conhecimentos, Habilidades e Atitudes (CHA), com vista a permitir a transparência e a comparação destes com os dos sistemas de outros países.',
    square_content_3:
      'Abrange os certificados e diplomas emitidos pelas entidades competentes do ensino básico e secundário, da formação profissional e do ensino superior, bem como a certificação de Qualificações Profissionais no âmbito do processo de Reconhecimento, Validação e Certificação de Competências Profissionais (RVCC Profissionais).',
    catalog_title: 'Catálogo Nacional de Qualificações (CNQ)',
    catalog_content_1:
      'O Catálogo Nacional de Qualificações é um dos componentes essenciais do Sistema Nacional de Qualificações, criado com a publicação do <span style="color:blue">Decreto-lei nº 66/2010, de 27 de dezembro </span>, e regulado, atualmente, pela <span style="color:blue">Portaria conjunta nº 9/2020, de 20 de fevereiro</span>.',
    catalog_content_2:
      'Abrange Qualificações Profissionais, baseadas em competências e resultados de aprendizagem, organizadas por Famílias Profissionais.',
    catalog_content_3:
      'O CNQ é um instrumento dinâmico, de gestão estratégica das qualificações profissionais elaboradas e ou atualizadas, com base nas necessidades atuais e emergentes do mercado, fatores essenciais para a competitividade e modernização das empresas e do tecido produtivo, assim como para o desenvolvimento humano, pessoal e social do indivíduo.',
    catalog_content_4:
      'A UC-SNQ é o serviço responsável pelo desenvolvimento e pela atualização, permanente, do CNQ, mediante a inclusão, exclusão ou alteração de referenciais de Qualificações Profissionais.',
    catalog_content_5:
      'Os Referenciais de Qualificações Profissionais disponibilizados, no CNQ, são elaborados e validados por Comités Técnicos Setoriais (CTS) e Conselhos Setoriais (COS), órgãos temporários, criados junto da UC-SNQ, para prestar apoio técnico e consultivo nesse processo, nos termos do disposto número 2 do artigo 9.º, <span style="color:blue">Decreto-Lei nº 7/2018, de 7 de fevereiro </span>.',
    catalog_content_6:
      'Cada Qualificação Profissional disponibilizada no CNQ é identificada por um Referencial de Competências (Perfil Profissional), um Referencial de Formação (Programa Formativo) e um Nível de qualificação, atribuído de acordo com o Quadro Nacional de Qualificações (QNQ).',
    catalog_content_7:
      'O Catálogo Nacional de Qualificações inclui referenciais de Qualificações Profissionais de Nível 2, 3, 4 e 5 do QNQ, organizados por Famílias Profissionais e disponibilizados a nível nacional.',
    catalog_content_8:
      'As Qualificações Profissionais do CNQ são instrumentos de referência para o Ensino Técnico, a Formação Profissional e o processo de Reconhecimento, Validação e Certificação de Competências Profissionais (RVCC Profissionais).',
    table: {
      title:
        'Requisitos que se deve ter para aceder a Cursos de QP oferecidas nas escolas técnicas ou nas entidades de formação profissional acreditadas:',
      requirement_access: 'Requisito de acesso (Habilitação exigida)',
      course: 'Curso de QP, por Nível do QNQ',
      req_1: 'Não é exigido (contanto que saiba ler e escrever)',
      access_1: 'Curso de QP de Nível 2',
      req_2: '8º ano de escolaridade',
      access_2: 'Curso de QP de Nível 3',
      req_3: '10º ano de escolaridade',
      access_3: 'Curso de QP de Nível 4',
      req_4: '12º ano de escolaridade',
      access_4: 'Curso de QP de Nível 5',
    },
  },
  ucsnqPage: {
    content_start: 'Unidade de Coordenação ',
    content_end: 'do Sistema Nacional de Qualificações (UC-SNQ)',
    content:
      'Serviço central do Estado, encarregue da coordenação, integração, conceção, execução e apoio técnico, no domínio das políticas de qualificação profissional.',
    mission: 'MISSÃO',
    mission_content:
      'É missão da UC-SNQ assegurar a estruturação do Sistema Nacional de Qualificações (SNQ).',
    vision: 'Visão',
    vision_content:
      'Promover e desenvolver a integração das ofertas de formação, através do Catálogo Nacional de Qualificações (CNQ).',
    direction: 'Direção e Enquadramento institucional',
    direction_content_1:
      'Os poderes de direção sobre a UC-SNQ são exercidos, conjuntamente e em articulação, pelo Ministério da Educação (ME) e Ministério das Finanças e do Fomento Empresarial (MFFE), membros do Governo responsáveis pelo setor da Educação, Formação e Emprego (EFE), respetivamente.',
    direction_content_2:
      'A UC-SNQ é dirigido por um Coordenador, nos termos dos artigos 10.º e seguintes, do Decreto-Lei nº 7/2018, de 7 fevereiro, e enquadra-se funcionalmente no MFFE, Departamento Governamental responsável pela área de Formação Profissional e Emprego.',
    articulation: 'Articulação Institucional',
    articulation_content:
      'Com vista a garantir a implementação das políticas, orientações e planos definidos neste domínio, a UC-SNQ articula-se com todas as entidades ativas no setor da Educação, Formação e Emprego, especificamente.',
    articulation_list_1:
      'Direção Geral do Emprego (DGE), serviço central responsável pela conceção e integração técnica e normativa, nos domínios da Formação Profissional, do Emprego e do Empreendedorismo, bem como dos Estágios Profissionais;',
    articulation_list_2:
      'Direção Nacional da Educação (DNE), serviço central responsável pelo setor da Educação Serviço do Ensino Técnico e da Educação de Jovens e Adultos (SETEJA);',
    articulation_list_3:
      'Instituto do Emprego e Formação Profissional (IEFP), e através deste, os Centros de Emprego e Formação Profissional (CEFP);',
    articulation_list_4: 'Os agentes económicos e empresariais.',
    articulation_list_5: 'Parceiros sociais.',
  },

  footer: {
    address: 'Endereço',
    address_content: 'Plateau, Ex BCV, 6º andar',
    phone: 'Telefone',
    email: 'Email',
    followUs: 'Segue-nos',
    home: 'Início',
    news: 'Notícias',
    link: 'Links',
    contact: 'Contatos',
    entity: 'ENTIDADES FORMADORAS',
    accreditation: 'Regime de Acreditação',
    approval: 'Homologação de Certificados',
    coordination: 'UNIDADE DE COORDENAÇÃO',
    whatUCSNQ: 'O que é UC-SNQ?',
    howWork: 'Como funciona?',
    about_us: 'SOBRE SNQ',
    what_is: 'O que é?',
    snq_structure: 'Estruturas do SNQ',
    principles: 'Principios e Objectivos',
    qualification_scheme: 'Regime de Qualificações',
    component: 'COMPONENTES',
  },
};

export default pt;
